import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Box from '@material-ui/core/Box/Box';
import { makeStyles } from '@material-ui/core/styles';
import useTheme from '@material-ui/core/styles/useTheme';
import React from 'react';
const useStyles = makeStyles({
    root: {
        width: '100%',
    },
    scrollPaper: {
        alignItems: 'baseline' // default center
    }
});
const OptionLevel_debug = (props) => {
    const { optionLevel } = props;
    const theme = useTheme();
    const classes = useStyles();
    // const toggleProfessionalOption = (e) => {
    //   let level = optionLevel;
    //   if (level > 1) level = 1;
    //   else level = 2;
    //   props.levelCallback(level);
    // }
    console.log(`OptionLevel2: level=${optionLevel}`);
    if (optionLevel < 1)
        return (_jsx(_Fragment, {}));
    // const msg = optionLevel > 1 ? "전문가 설정 닫기" : "전문가 설정 열기";
    console.log(`OptionLevel2: step 2, level=${optionLevel}`);
    return (_jsxs(React.Fragment, { children: [_jsx(Box, Object.assign({ component: "div", className: classes.root }, { children: _jsx(Box, Object.assign({ fontSize: 16, fontWeight: "fontWeightRegular" }, { children: "Level 2 Options " })) })), _jsx(Box, Object.assign({ component: "div", className: classes.root, style: { display: "flex", justifyContent: "center" } }, { children: _jsx(Box, Object.assign({ borderColor: theme.palette.primary.main, border: 1 }, { children: "Level 2 Options" })) }))] }));
};
export default OptionLevel_debug;
//# sourceMappingURL=OptionLevelDebug.js.map